import { render } from "./nuevaNoticia.vue?vue&type=template&id=61e6112a&scoped=true"
import script from "./nuevaNoticia.vue?vue&type=script&lang=js"
export * from "./nuevaNoticia.vue?vue&type=script&lang=js"

import "./nuevaNoticia.vue?vue&type=style&index=0&id=61e6112a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61e6112a"]])

export default __exports__